import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-select-dialog-pricing',
  templateUrl: './select-dialog-pricing.component.html',
  styleUrls: ['./select-dialog-pricing.component.scss']
})
export class SelectDialogPricingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
